module.exports = __webpack_public_path__ + "img/img9.5b98a354.png";